import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const customizationModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			// eslint-disable-next-line import/dynamic-import-chunkname
			import(
				/* webpackChunkName: "async-navigation-global-side-navigation-customization-modal" */ './index'
			).then(({ CustomizationModal }) => CustomizationModal),
		{
			moduleId: 'navigation.global-side-navigation.customization-modal',
		},
	),
	getPreloadProps: () => ({}),
});
